module.exports = __webpack_public_path__ + "2e875bb73f33ba5a352e2ae6b524d133.png";